import { render, staticRenderFns } from "./livingSet.vue?vue&type=template&id=cd67bf52&scoped=true&"
import script from "./livingSet.vue?vue&type=script&lang=js&"
export * from "./livingSet.vue?vue&type=script&lang=js&"
import style0 from "./livingSet.vue?vue&type=style&index=0&id=cd67bf52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd67bf52",
  null
  
)

export default component.exports